import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OcppSessionAnalysisParameters } from '../../api/ocpp-session-analysis-api.service';

@Component({
  selector: 'app-launch-session-analysis-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './launch-session-analysis-dialog.component.html',
  styleUrls: ['./launch-session-analysis-dialog.component.scss']
})
export class LaunchSessionAnalysisDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<LaunchSessionAnalysisDialogComponent, OcppSessionAnalysisParameters | undefined>
  );

  readonly form = new FormGroup({
    windowStart: new FormControl(this.localInput(this.shiftDays(-1)), { nonNullable: true, validators: [Validators.required] }),
    windowEnd: new FormControl(this.localInput(this.shiftDays(0)), { nonNullable: true, validators: [Validators.required] }),
    namespaces: new FormControl('', { nonNullable: true }),
    chargePointIds: new FormControl('', { nonNullable: true }),
    vendors: new FormControl('', { nonNullable: true }),
    models: new FormControl('', { nonNullable: true }),
    firmwareVersions: new FormControl('', { nonNullable: true })
  });

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    const value = this.form.getRawValue();
    this.dialogRef.close({
      windowStart: new Date(value.windowStart).toISOString(),
      windowEnd: new Date(value.windowEnd).toISOString(),
      namespaces: this.split(value.namespaces),
      chargePointIds: this.split(value.chargePointIds),
      vendors: this.split(value.vendors),
      models: this.split(value.models),
      firmwareVersions: this.split(value.firmwareVersions)
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private split(value: string): string[] {
    return value.split(',').map(part => part.trim()).filter(part => part.length > 0);
  }

  private shiftDays(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() + days);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  private localInput(date: Date): string {
    const pad = (value: number) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }
}
